import React, { type ReactNode } from 'react'

import {
  Button,
  ButtonGroup,
  Colors,
  DashboardLogo,
  useMediaQueryContext,
} from '@fourthwall/components'

import * as S from './ConfirmBar.styled'

export type ConfirmBarViewProps = {
  dashboardLogo: {
    name: string | undefined
    to: string
  }
  isOpen: boolean
  isLoading?: boolean
  confirmLabel?: string
  message?: string
  additionalElement?: ReactNode
  onConfirm: () => void
  onCancel?: () => void
}

export const ConfirmBarView = ({
  dashboardLogo,
  isOpen = false,
  isLoading = false,
  confirmLabel = 'Save',
  message = 'Unsaved changes',
  onConfirm,
  onCancel,
  additionalElement,
}: ConfirmBarViewProps) => {
  const { tablet } = useMediaQueryContext()

  return (
    <S.Container $isOpen={isOpen} data-testid="ConfirmBar">
      <S.LogoContainer>
        <DashboardLogo name={dashboardLogo.name} to={dashboardLogo.to} color={Colors.GS1000} />
      </S.LogoContainer>
      <S.Content>
        {tablet && <S.Message>{message}</S.Message>}
        <ButtonGroup space={tablet ? 'large' : 'medium'}>
          {onCancel && (
            <Button label="Discard" size="small" disabled={isLoading} onClick={onCancel} />
          )}
          <ButtonGroup space="small">
            <Button
              label={confirmLabel}
              appearance="primary"
              size="small"
              loading={isLoading}
              disabled={isLoading}
              onClick={onConfirm}
            />
            {additionalElement}
          </ButtonGroup>
        </ButtonGroup>
      </S.Content>
    </S.Container>
  )
}
